var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3 mt-sm-5"},[_c(_vm.$store.getters.stateName,{tag:"component"}),_c('alert-tray'),_c('modal-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }